import { ILoyaltyRewardsRequest, ILoyaltyRewardsResponse } from './types/fetch-model';
import { post } from '../api';

export const fetchLoyaltyRewardsRequest = (params: ILoyaltyRewardsRequest) =>
  post<ILoyaltyRewardsResponse>('post-loyalty-rewards', params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
